/*
 * SK Art — generative motion-design visuals (no photos):
 *   [data-sk-bloom]  a cherry branch that grows in ink, then blossoms, while scrolling
 *   [data-sk-enso]   a brush ensō drawn on scroll, then a red hanko seal stamped
 *   [data-sk-dusk]   a layered dusk landscape (canvas) with parallax and falling petals
 * Everything is seeded, so each visitor sees the same composition.
 */
(function () {
  if (!window.gsap || !window.ScrollTrigger) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isSmall = window.matchMedia('(max-width: 749px)').matches;
  var SVGNS = 'http://www.w3.org/2000/svg';

  function rng(seed) {
    var a = seed >>> 0;
    return function () {
      a = (a + 0x6d2b79f5) >>> 0;
      var t = a;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function el(name, attrs) {
    var n = document.createElementNS(SVGNS, name);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }

  /* ---------- Branch generator (shared by bloom & dusk) ---------- */
  function growBranch(opts) {
    var R = rng(opts.seed || 7);
    var segs = [];
    var flowers = [];
    var maxDepth = opts.depth || 6;

    function grow(x, y, angle, len, width, depth, t0) {
      var ex = x + Math.cos(angle) * len;
      var ey = y + Math.sin(angle) * len;
      var bend = (R() - 0.5) * 0.5 * len;
      var cx = (x + ex) / 2 + Math.cos(angle + Math.PI / 2) * bend;
      var cy = (y + ey) / 2 + Math.sin(angle + Math.PI / 2) * bend;
      var t1 = t0 + len * 0.0022;
      segs.push({ x: x, y: y, cx: cx, cy: cy, ex: ex, ey: ey, w: width, t0: t0, t1: t1, depth: depth });

      if (depth >= 2) {
        // blossoms along the twig
        var n = depth >= 4 ? 2 : 1;
        for (var i = 0; i < n; i++) {
          if (R() < 0.55) {
            var u = 0.35 + R() * 0.6;
            var px = (1 - u) * (1 - u) * x + 2 * (1 - u) * u * cx + u * u * ex;
            var py = (1 - u) * (1 - u) * y + 2 * (1 - u) * u * cy + u * u * ey;
            flowers.push({ x: px + (R() - 0.5) * 30, y: py + (R() - 0.5) * 30, r: 14 + R() * 16, rot: R() * 72, t: t0 + (t1 - t0) * u + 0.04, bud: R() < 0.25 });
          }
        }
      }
      if (depth >= maxDepth) {
        flowers.push({ x: ex, y: ey, r: 16 + R() * 14, rot: R() * 72, t: t1 + 0.03, bud: R() < 0.3 });
        return;
      }
      var kids = depth < 2 ? 2 : R() < 0.3 ? 3 : 2;
      for (var k = 0; k < kids; k++) {
        var spread = (0.32 + R() * 0.5) * (k % 2 ? 1 : -1);
        var lift = (-Math.PI / 2 - angle) * 0.12;
        grow(ex, ey, angle + spread + lift, len * (0.64 + R() * 0.18), width * 0.64, depth + 1, t1);
      }
    }

    grow(opts.x, opts.y, opts.angle, opts.len, opts.width, 0, 0);
    var tMax = 0;
    segs.forEach(function (s) { tMax = Math.max(tMax, s.t1); });
    flowers.forEach(function (f) { tMax = Math.max(tMax, f.t); });
    segs.forEach(function (s) { s.t0 /= tMax; s.t1 /= tMax; });
    flowers.forEach(function (f) { f.t /= tMax; });
    return { segs: segs, flowers: flowers };
  }

  function flowerNode(f) {
    var g = el('g', { transform: 'translate(' + f.x.toFixed(1) + ' ' + f.y.toFixed(1) + ')' });
    var inner = el('g', { class: 'sk-flower' });
    if (f.bud) {
      inner.appendChild(el('ellipse', { rx: (f.r * 0.32).toFixed(1), ry: (f.r * 0.5).toFixed(1), fill: '#e59aa6', transform: 'rotate(' + f.rot.toFixed(0) + ')' }));
    } else {
      for (var i = 0; i < 5; i++) {
        inner.appendChild(el('ellipse', {
          cx: 0, cy: (-f.r * 0.62).toFixed(1), rx: (f.r * 0.46).toFixed(1), ry: (f.r * 0.62).toFixed(1),
          fill: i % 2 ? '#f7d6da' : '#f3c9cf', stroke: '#d79aa3', 'stroke-width': 0.8,
          transform: 'rotate(' + (f.rot + i * 72).toFixed(0) + ')',
        }));
      }
      inner.appendChild(el('circle', { r: (f.r * 0.24).toFixed(1), fill: '#b9707a' }));
      for (var s = 0; s < 6; s++) {
        var a = (s / 6) * Math.PI * 2 + f.rot;
        inner.appendChild(el('circle', { cx: (Math.cos(a) * f.r * 0.38).toFixed(1), cy: (Math.sin(a) * f.r * 0.38).toFixed(1), r: 1.4, fill: '#8a3f4a' }));
      }
    }
    g.appendChild(inner);
    return { g: g, inner: inner };
  }

  /* ---------- Bloom: branch grows with the scroll (CSS sticky, no pin) ---------- */
  function initBloom(section) {
    var host = section.querySelector('[data-sk-bloom-svg]');
    var seed = parseInt(section.getAttribute('data-seed'), 10) || 11;
    var tree = isSmall
      ? growBranch({ seed: seed, x: 260, y: 1040, angle: -1.3, len: 300, width: 34, depth: 6 })
      : growBranch({ seed: seed, x: 140, y: 1020, angle: -1.15, len: 250, width: 30, depth: 6 });
    var svg = el('svg', { viewBox: '0 0 1000 1000', preserveAspectRatio: 'xMidYMid meet', 'aria-hidden': 'true' });
    var gBranch = el('g', { fill: 'none', stroke: '#1a1715', 'stroke-linecap': 'round' });
    var gFlowers = el('g');
    svg.appendChild(gBranch);
    svg.appendChild(gFlowers);

    var paths = tree.segs.map(function (s) {
      var p = el('path', {
        d: 'M' + s.x.toFixed(1) + ' ' + s.y.toFixed(1) + 'Q' + s.cx.toFixed(1) + ' ' + s.cy.toFixed(1) + ' ' + s.ex.toFixed(1) + ' ' + s.ey.toFixed(1),
        'stroke-width': Math.max(1.2, s.w).toFixed(1),
        pathLength: 1,
        'stroke-dasharray': '1 1',
        'stroke-dashoffset': 1,
      });
      gBranch.appendChild(p);
      return { node: p, t0: s.t0, t1: s.t1, last: -1 };
    });
    var flowers = tree.flowers.map(function (f) {
      var n = flowerNode(f);
      n.inner.style.transform = 'scale(0)';
      gFlowers.appendChild(n.g);
      return { node: n.inner, t: f.t, last: -1 };
    });
    host.appendChild(svg);

    var lines = Array.from(section.querySelectorAll('[data-at]')).map(function (n) {
      return { node: n, at: parseFloat(n.getAttribute('data-at')) || 0, on: false };
    });

    function render(p) {
      var growth = clamp01(p * 1.25);
      for (var i = 0; i < paths.length; i++) {
        var s = paths[i];
        var v = clamp01((growth - s.t0) / Math.max(0.0001, s.t1 - s.t0));
        v = Math.round(v * 100) / 100;
        if (v !== s.last) { s.node.setAttribute('stroke-dashoffset', (1 - v).toFixed(2)); s.last = v; }
      }
      for (var j = 0; j < flowers.length; j++) {
        var f = flowers[j];
        var k = clamp01((growth - f.t) / 0.08);
        var e = k === 0 ? 0 : 1 - Math.pow(1 - k, 3) * Math.cos(k * 4) * 1;
        e = Math.round(clamp01(e) * 100) / 100;
        if (e !== f.last) { f.node.style.transform = 'scale(' + e + ')'; f.last = e; }
      }
      lines.forEach(function (l) {
        var on = p >= l.at;
        if (on !== l.on) { l.on = on; l.node.classList.toggle('is-on', on); }
      });
    }

    if (reduce) { render(1); return; }
    render(0);
    ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      end: 'bottom bottom',
      onUpdate: function (self) { render(self.progress); },
      onRefresh: function (self) { render(self.progress); },
    });
  }

  /* ---------- Ensō + hanko ---------- */
  function initEnso(section) {
    var host = section.querySelector('[data-sk-enso-svg]');
    var R = rng(23);
    var svg = el('svg', { viewBox: '0 0 1000 1000', 'aria-hidden': 'true' });
    function circlePath(r, jitter, a0, a1) {
      var d = '';
      var steps = 140;
      for (var i = 0; i <= steps; i++) {
        var a = a0 + (a1 - a0) * (i / steps);
        var rr = r + Math.sin(a * 3 + 1.3) * jitter + Math.sin(a * 7) * jitter * 0.4;
        var x = 500 + Math.cos(a) * rr;
        var y = 500 + Math.sin(a) * rr;
        d += (i ? 'L' : 'M') + x.toFixed(1) + ' ' + y.toFixed(1);
      }
      return d;
    }
    var a0 = (-100 * Math.PI) / 180;
    var a1 = (238 * Math.PI) / 180;
    var strokes = [];
    var main = el('path', { d: circlePath(360, 8, a0, a1), fill: 'none', stroke: '#1a1715', 'stroke-width': 54, 'stroke-linecap': 'round', opacity: 0.92, pathLength: 1, 'stroke-dasharray': '1 1', 'stroke-dashoffset': 1 });
    svg.appendChild(main);
    strokes.push(main);
    for (var i = 0; i < 7; i++) {
      var off = (R() - 0.5) * 60;
      var dry = el('path', {
        d: circlePath(360 + off, 10, a0 + R() * 0.15, a1 - R() * 0.4),
        fill: 'none', stroke: '#1a1715', 'stroke-width': (2 + R() * 5).toFixed(1), 'stroke-linecap': 'round',
        opacity: (0.35 + R() * 0.4).toFixed(2), pathLength: 1, 'stroke-dasharray': '1 1', 'stroke-dashoffset': 1,
      });
      svg.appendChild(dry);
      strokes.push(dry);
    }
    var seal = el('g', { class: 'sk-seal', transform: 'translate(760 760) rotate(-7)' });
    seal.appendChild(el('rect', { x: -78, y: -78, width: 156, height: 156, rx: 10, fill: '#b3262e' }));
    seal.appendChild(el('rect', { x: -66, y: -66, width: 132, height: 132, rx: 6, fill: 'none', stroke: '#f3e6e1', 'stroke-width': 4 }));
    var t = el('text', { x: 0, y: 34, 'text-anchor': 'middle', 'font-size': 96, fill: '#f3e6e1', 'font-family': "'Noto Serif JP', serif" });
    t.textContent = section.getAttribute('data-seal') || '桜';
    seal.appendChild(t);
    var sealWrap = el('g', { class: 'sk-seal-wrap' });
    sealWrap.appendChild(seal);
    svg.appendChild(sealWrap);
    host.appendChild(svg);

    if (reduce) {
      strokes.forEach(function (s) { s.setAttribute('stroke-dashoffset', 0); });
      return;
    }
    gsap.set(sealWrap, { opacity: 0, scale: 1.8, transformOrigin: '760px 760px' });
    var tl = gsap.timeline({
      scrollTrigger: { trigger: section, start: 'top 75%', end: isSmall ? 'center 45%' : 'center center', scrub: 0.4 },
    });
    strokes.forEach(function (s, i) {
      tl.to(s, { attr: { 'stroke-dashoffset': 0 }, ease: 'power2.inOut', duration: 1 }, i === 0 ? 0 : 0.05 + i * 0.03);
    });
    gsap.to(sealWrap, {
      opacity: 1, scale: 1, duration: 0.45, ease: 'back.out(2.2)',
      scrollTrigger: { trigger: section, start: isSmall ? 'center 55%' : 'center 62%', toggleActions: 'play none none reverse' },
    });
  }

  /* ---------- Dusk landscape (canvas) ---------- */
  function initDusk(section) {
    var canvas = section.querySelector('[data-sk-dusk-canvas]');
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, isSmall ? 1.5 : 2);
    var W = 0, H = 0, layers = [], moon = null, branch = null;
    var progress = 0.5, visible = false;
    var R = rng(31);
    var petals = [];
    var PETALS = isSmall ? 34 : 70;

    function ridge(seed, base, amp, roughness) {
      var r = rng(seed);
      var waves = [];
      for (var i = 0; i < 5; i++) waves.push({ f: (0.6 + r() * 2.8) * (1 + i * roughness), a: amp / (i + 1), p: r() * 10 });
      return function (x) {
        var y = base;
        for (var i = 0; i < waves.length; i++) y -= Math.sin(x * waves[i].f + waves[i].p) * waves[i].a;
        return y;
      };
    }

    function build() {
      W = canvas.clientWidth; H = canvas.clientHeight;
      canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
      var specs = [
        { base: 0.58, amp: 0.06, color: '#5a3c45', mist: 0.1, factor: 0.04, seed: 3 },
        { base: 0.66, amp: 0.07, color: '#3d2a30', mist: 0.08, factor: 0.1, seed: 5 },
        { base: 0.75, amp: 0.06, color: '#261b1e', mist: 0.06, factor: 0.18, seed: 8 },
        { base: 0.86, amp: 0.05, color: '#141110', mist: 0, factor: 0.3, seed: 13 },
      ];
      layers = specs.map(function (s) {
        var c = document.createElement('canvas');
        var ch = Math.round(H * 1.5);
        c.width = Math.round(W * dpr); c.height = Math.round(ch * dpr);
        var g = c.getContext('2d');
        g.scale(dpr, dpr);
        var f = ridge(s.seed, s.base * H, s.amp * H, 0.9);
        g.beginPath();
        g.moveTo(0, ch);
        for (var x = 0; x <= W; x += 6) g.lineTo(x, f(x / W * 6));
        g.lineTo(W, ch);
        g.closePath();
        g.fillStyle = s.color;
        g.fill();
        if (s.mist) {
          var m = g.createLinearGradient(0, s.base * H - s.amp * H * 1.5, 0, s.base * H + H * 0.12);
          m.addColorStop(0, 'rgba(240,215,220,0)');
          m.addColorStop(0.6, 'rgba(240,215,220,' + s.mist + ')');
          m.addColorStop(1, 'rgba(240,215,220,0)');
          g.fillStyle = m;
          g.fillRect(0, 0, W, ch);
        }
        return { canvas: c, factor: s.factor };
      });

      var size = Math.min(W, H);
      moon = { x: W * (isSmall ? 0.62 : 0.7), y: H * 0.34, r: size * (isSmall ? 0.16 : 0.12) };

      // Foreground branch silhouette (top corner)
      branch = document.createElement('canvas');
      branch.width = Math.round(W * dpr); branch.height = Math.round(H * dpr);
      var b = branch.getContext('2d');
      b.scale(dpr, dpr);
      var s = (isSmall ? W / 520 : W / 1400);
      var tree = growBranch({ seed: 4, x: W + 30, y: -20, angle: 2.55, len: 190 * s * 1.6, width: 18 * s * 1.6, depth: 5 });
      b.strokeStyle = '#0d0b0a'; b.lineCap = 'round';
      tree.segs.forEach(function (sg) {
        b.lineWidth = Math.max(1, sg.w);
        b.beginPath(); b.moveTo(sg.x, sg.y); b.quadraticCurveTo(sg.cx, sg.cy, sg.ex, sg.ey); b.stroke();
      });
      tree.flowers.forEach(function (f) {
        var r = f.r * s * 0.9;
        for (var i = 0; i < 5; i++) {
          var a = (f.rot + i * 72) * Math.PI / 180;
          b.fillStyle = i % 2 ? '#e7aab3' : '#f2c4ca';
          b.beginPath();
          b.ellipse(f.x + Math.sin(a) * r * 0.6, f.y - Math.cos(a) * r * 0.6, r * 0.45, r * 0.6, a, 0, Math.PI * 2);
          b.fill();
        }
        b.fillStyle = '#9c4e5a';
        b.beginPath(); b.arc(f.x, f.y, r * 0.22, 0, Math.PI * 2); b.fill();
      });

      petals = [];
      for (var i = 0; i < PETALS; i++) {
        petals.push({ x: R() * W, y: R() * H, s: 3 + R() * 6, v: 14 + R() * 30, sway: 0.5 + R(), ph: R() * 6.28, spin: 0.5 + R() * 2 });
      }
    }

    function draw(time) {
      if (!W || !H || !branch || !branch.width) return;
      var t = time / 1000;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var sky = ctx.createLinearGradient(0, 0, 0, H);
      sky.addColorStop(0, '#0f0d0c');
      sky.addColorStop(0.45, '#2a1c22');
      sky.addColorStop(0.75, '#7a4652');
      sky.addColorStop(1, '#c58d96');
      ctx.fillStyle = sky;
      ctx.fillRect(0, 0, W, H);

      var shift = progress - 0.5;
      var my = moon.y + shift * H * 0.12;
      var glow = ctx.createRadialGradient(moon.x, my, moon.r * 0.6, moon.x, my, moon.r * 3.2);
      glow.addColorStop(0, 'rgba(246,215,218,0.35)');
      glow.addColorStop(1, 'rgba(246,215,218,0)');
      ctx.fillStyle = glow;
      ctx.fillRect(0, 0, W, H);
      ctx.fillStyle = '#f6dfe0';
      ctx.beginPath(); ctx.arc(moon.x, my, moon.r, 0, Math.PI * 2); ctx.fill();

      for (var i = 0; i < layers.length; i++) {
        var L = layers[i];
        ctx.drawImage(L.canvas, 0, shift * H * L.factor * -1.4, W, H * 1.5);
      }

      ctx.fillStyle = 'rgba(240,190,198,0.85)';
      var dt = 1 / 60;
      for (var k = 0; k < petals.length; k++) {
        var p = petals[k];
        p.y += p.v * dt;
        p.x += Math.sin(t * p.sway + p.ph) * 0.4 - 0.15;
        if (p.y > H + 10) { p.y = -10; p.x = Math.random() * W; }
        if (p.x < -10) p.x = W + 10;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(t * p.spin + p.ph);
        ctx.scale(1, Math.abs(Math.sin(t * p.spin * 0.7 + p.ph)) * 0.7 + 0.3);
        ctx.beginPath(); ctx.ellipse(0, 0, p.s * 0.6, p.s, 0, 0, Math.PI * 2); ctx.fill();
        ctx.restore();
      }

      ctx.drawImage(branch, 0, shift * H * -0.25, W, H);
    }

    build();
    draw(0);
    var resizeT;
    function onResize() {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        if (canvas.clientWidth !== W || Math.abs(canvas.clientHeight - H) > 120) { build(); draw(performance.now()); }
      }, 200);
    }
    if (window.ResizeObserver) new ResizeObserver(onResize).observe(canvas);
    else window.addEventListener('resize', onResize);
    if (reduce) return;

    new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(section);
    ScrollTrigger.create({
      trigger: section, start: 'top bottom', end: 'bottom top',
      onUpdate: function (self) { progress = self.progress; },
    });
    gsap.ticker.add(function (time) { if (visible) draw(time * 1000); });
  }

  /* ---------- Anatomy: a line-art hoodie that turns with the scroll ---------- */
  var HOODIE = {
    front: [
      'M232 174C220 112 250 70 300 68C350 70 380 112 368 174',
      'M256 180C258 136 280 112 300 112C320 112 342 136 344 180C328 198 272 198 256 180Z',
      'M232 174C250 200 350 200 368 174',
      'M232 174C200 178 168 186 150 200C128 260 112 360 104 470L100 540',
      'M100 540L140 545L146 478',
      'M146 478C152 400 162 330 176 280C178 380 176 470 178 560',
      'M368 174C400 178 432 186 450 200C472 260 488 360 496 470L500 540',
      'M500 540L460 545L454 478',
      'M454 478C448 400 438 330 424 280C422 380 424 470 422 560',
      'M178 560L178 600C260 610 340 610 422 600L422 560',
      'M178 560C260 570 340 570 422 560',
      'M103 512L144 516', 'M497 512L456 516',
      'M286 194C284 230 287 255 283 286', 'M314 194C316 230 313 255 317 286',
      'M281 286L285 300', 'M319 286L315 300',
    ],
    folds: ['M210 330C230 360 232 400 222 430', 'M390 330C370 360 368 400 378 430', 'M250 470C262 500 262 530 254 552'],
    back: [
      'M230 176C218 108 252 62 300 60C348 62 382 108 370 176C350 192 250 192 230 176Z',
      'M300 62C302 110 300 150 300 184',
      'M232 174C200 178 168 186 150 200C128 260 112 360 104 470L100 540',
      'M100 540L140 545L146 478',
      'M146 478C152 400 162 330 176 280C178 380 176 470 178 560',
      'M368 174C400 178 432 186 450 200C472 260 488 360 496 470L500 540',
      'M500 540L460 545L454 478',
      'M454 478C448 400 438 330 424 280C422 380 424 470 422 560',
      'M178 560L178 600C260 610 340 610 422 600L422 560',
      'M178 560C260 570 340 570 422 560',
      'M103 512L144 516', 'M497 512L456 516',
    ],
    silhouette: 'M232 172C200 178 168 186 150 200C128 260 112 360 104 470L100 540L140 545L146 478C152 400 162 330 176 280C178 380 176 470 178 560L178 600C260 610 340 610 422 600L422 560C424 470 422 380 424 280C438 330 448 400 454 478L460 545L500 540L496 470C488 360 472 260 450 200C432 186 400 178 368 172C380 110 350 70 300 68C250 70 220 110 232 172Z',
    side: [
      'M122 176C70 166 58 100 104 72C140 54 186 70 190 110C192 140 176 164 152 178',
      'M96 182C80 262 78 382 82 560L84 600L182 600L180 560C186 420 188 300 170 190',
      'M150 202C162 300 160 420 152 520L150 545L180 545L184 520C188 400 186 300 176 232',
      'M84 560L180 560', 'M152 512L182 514',
    ],
    sideSilhouette: 'M122 176C70 166 58 100 104 72C140 54 186 70 190 110C192 140 176 164 170 190C188 300 186 420 184 520L180 545L180 560L182 600L84 600L82 560C78 382 80 262 96 182Z',
  };
  var SWATCHES = { noir: '#1d1b1a', blanc: '#f4f1ec', sable: '#d8c19f', marine: '#1f2b4c', 'vert sapin': '#1e4a3f', rose: '#efa9c2' };

  function inkPath(d, extra) {
    var attrs = { d: d, class: 'sk-ink', pathLength: 1, 'stroke-dasharray': '1 1', 'stroke-dashoffset': 1 };
    for (var k in extra) attrs[k] = extra[k];
    return el('path', attrs);
  }

  function initAnatomy(section) {
    var turn = section.querySelector('[data-turn]');
    var caps = Array.from(section.querySelectorAll('[data-cap]'));
    var swatchEls = Array.from(section.querySelectorAll('[data-swatch]'));
    var bar = section.querySelector('[data-anatomy-progress]');

    function face(kind, viewW) {
      var svg = el('svg', { viewBox: '0 0 ' + viewW + ' 700', class: 'sk-face sk-face--' + kind, 'aria-hidden': 'true' });
      var fill = el('path', { d: kind === 'side' ? HOODIE.sideSilhouette : HOODIE.silhouette, class: 'sk-face__fill' });
      svg.appendChild(fill);
      return { svg: svg, fill: fill, strokes: [], late: [] };
    }

    var F = face('front', 600);
    HOODIE.front.forEach(function (d) { var p = inkPath(d); F.svg.appendChild(p); F.strokes.push(p); });
    HOODIE.folds.forEach(function (d) { var p = inkPath(d, { class: 'sk-ink sk-ink--soft' }); F.svg.appendChild(p); F.strokes.push(p); });

    var B = face('back', 600);
    HOODIE.back.forEach(function (d) { var p = inkPath(d); B.svg.appendChild(p); B.strokes.push(p); });
    // Back motif: katana, branches, blossoms, calligraphy
    var motif = [];
    var katana = ['M290 200L310 200L308 205L292 205Z', 'M292 205L308 205L308 285L292 285Z', 'M278 292A22 7 0 1 0 322 292A22 7 0 1 0 278 292', 'M294 299L306 299L306 306L294 306Z', 'M294 306L294 520L300 534L306 520L306 306', 'M306 316C330 330 318 352 334 368'];
    for (var y = 210; y < 284; y += 10) { katana.push('M292 ' + y + 'L308 ' + (y + 9)); katana.push('M308 ' + y + 'L292 ' + (y + 9)); }
    katana.forEach(function (d, i) { motif.push({ node: inkPath(d, { class: 'sk-ink sk-ink--fine' }), t: 0.02 * i / katana.length }); });
    [{ seed: 5, x: 296, y: 476, angle: -2.25, len: 46 }, { seed: 9, x: 304, y: 432, angle: -0.85, len: 42 }, { seed: 14, x: 298, y: 380, angle: -2.5, len: 32 }].forEach(function (o, bi) {
      var tree = growBranch({ seed: o.seed, x: o.x, y: o.y, angle: o.angle, len: o.len, width: 3.2, depth: 4 });
      tree.segs.forEach(function (s) {
        var d = 'M' + s.x.toFixed(1) + ' ' + s.y.toFixed(1) + 'Q' + s.cx.toFixed(1) + ' ' + s.cy.toFixed(1) + ' ' + s.ex.toFixed(1) + ' ' + s.ey.toFixed(1);
        var p = inkPath(d, { class: 'sk-ink sk-ink--fine' });
        p.style.strokeWidth = Math.max(0.6, s.w * 0.55).toFixed(2);
        motif.push({ node: p, t: 0.25 + bi * 0.1 + s.t0 * 0.45 });
      });
      tree.flowers.forEach(function (f) {
        f.r *= 0.42;
        var n = flowerNode(f);
        n.inner.style.transform = 'scale(0)';
        motif.push({ node: n.g, flower: n.inner, t: 0.45 + bi * 0.1 + f.t * 0.4 });
      });
    });
    var kanji = el('text', { x: 336, y: 318, class: 'sk-kanji', 'font-size': 17 });
    kanji.textContent = section.getAttribute('data-proverb') || '花は桜木、人は武士';
    motif.push({ node: kanji, text: true, t: 0.9 });
    motif.forEach(function (m) { B.svg.appendChild(m.node); });

    var S = face('side', 260);
    HOODIE.side.forEach(function (d) { var p = inkPath(d); S.svg.appendChild(p); S.strokes.push(p); });

    // Markers live on the face they describe, so they turn with it.
    caps.forEach(function (c, i) {
      var kind = c.getAttribute('data-face');
      if (kind === 'colors') return;
      var host = kind === 'back' ? B : F;
      var g = el('g', { class: 'sk-marker', transform: 'translate(' + c.getAttribute('data-x') + ' ' + c.getAttribute('data-y') + ')' });
      g.appendChild(el('circle', { r: 15, class: 'sk-marker__ring' }));
      g.appendChild(el('circle', { r: 3.2, class: 'sk-marker__dot' }));
      host.svg.appendChild(g);
      c._marker = g;
    });

    turn.appendChild(F.svg);
    turn.appendChild(S.svg);
    turn.appendChild(B.svg);

    // Phases
    var fronts = caps.filter(function (c) { return c.getAttribute('data-face') === 'front'; });
    var backs = caps.filter(function (c) { return c.getAttribute('data-face') === 'back'; });
    var colors = caps.filter(function (c) { return c.getAttribute('data-face') === 'colors'; });
    fronts.forEach(function (c, i) { c._at = 0.1 + (0.3 * i) / Math.max(1, fronts.length); });
    backs.forEach(function (c, i) { c._at = 0.6 + (0.24 * i) / Math.max(1, backs.length); });
    colors.forEach(function (c) { c._at = 0.86; });

    var palette = swatchEls.map(function (s) {
      var name = (s.getAttribute('data-swatch') || '').toLowerCase();
      var hex = SWATCHES[name] || '#d8c19f';
      s.style.background = hex;
      return hex;
    });

    function lum(hex) {
      var n = parseInt(hex.slice(1), 16);
      return (0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255;
    }

    var rotTo = gsap.quickTo(turn, 'rotationY', { duration: isSmall ? 0.25 : 0.6, ease: 'power3.out' });
    gsap.set(turn, { rotationX: 6, transformPerspective: 0 });
    var lastCap = null, lastColor = -1;

    function setStrokes(list, v) {
      for (var i = 0; i < list.length; i++) list[i].setAttribute('stroke-dashoffset', (1 - v).toFixed(3));
    }

    function render(p) {
      setStrokes(F.strokes, clamp01(p / 0.1));
      setStrokes(S.strokes, clamp01((p - 0.38) / 0.1));
      setStrokes(B.strokes, clamp01((p - 0.42) / 0.12));
      var mp = clamp01((p - 0.5) / 0.14);
      motif.forEach(function (m) {
        var v = clamp01((mp - m.t) / 0.12);
        if (m.flower) m.flower.style.transform = 'scale(' + (v === 0 ? 0 : (1 - Math.pow(1 - v, 3)).toFixed(2)) + ')';
        else if (m.text) m.node.style.opacity = v.toFixed(2);
        else m.node.setAttribute('stroke-dashoffset', (1 - v).toFixed(3));
      });

      var angle = 180 * clamp01((p - 0.4) / 0.16);
      rotTo(angle);
      var edge = 1 - Math.abs(Math.cos((angle * Math.PI) / 180));
      S.svg.style.opacity = edge.toFixed(2);

      var active = null;
      caps.forEach(function (c) { if (p >= c._at) active = c; });
      if (p < 0.1) active = null;
      if (active !== lastCap) {
        caps.forEach(function (c) {
          var on = c === active;
          c.classList.toggle('is-on', on);
          if (c._marker) c._marker.classList.toggle('is-on', on);
        });
        lastCap = active;
      }

      var ci = -1;
      if (p >= 0.86 && palette.length) ci = Math.min(palette.length - 1, Math.floor(((p - 0.86) / 0.14) * palette.length));
      if (ci !== lastColor) {
        lastColor = ci;
        var hex = ci >= 0 ? palette[ci] : null;
        [F, B, S].forEach(function (f) {
          f.fill.style.fill = hex || 'transparent';
          f.svg.style.setProperty('--hd-ink', hex && lum(hex) < 0.45 ? '#f1ece4' : '#1a1715');
        });
        swatchEls.forEach(function (s, i) { s.classList.toggle('is-on', i === ci); });
      }
      if (bar) bar.style.transform = 'scaleX(' + p.toFixed(3) + ')';
    }

    if (reduce) { render(0.62); return; }
    render(0);
    ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      end: 'bottom bottom',
      onUpdate: function (self) { render(self.progress); },
      onRefresh: function (self) { render(self.progress); },
    });
  }

  /* ---------- Footer emblem: draws itself once when it enters ---------- */
  function initEmblem(node) {
    if (reduce || !('IntersectionObserver' in window)) { node.classList.add('is-drawn'); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { node.classList.add('is-drawn'); io.disconnect(); }
    }, { threshold: 0.4 });
    io.observe(node);
  }

  function init(scope) {
    scope.querySelectorAll('[data-sk-anatomy]:not([data-sk-art])').forEach(function (n) { n.setAttribute('data-sk-art', ''); initAnatomy(n); });
    scope.querySelectorAll('[data-sk-emblem]:not([data-sk-art])').forEach(function (n) { n.setAttribute('data-sk-art', ''); initEmblem(n); });
    scope.querySelectorAll('[data-sk-bloom]:not([data-sk-art])').forEach(function (n) { n.setAttribute('data-sk-art', ''); initBloom(n); });
    scope.querySelectorAll('[data-sk-enso]:not([data-sk-art])').forEach(function (n) { n.setAttribute('data-sk-art', ''); initEnso(n); });
    scope.querySelectorAll('[data-sk-dusk]:not([data-sk-art])').forEach(function (n) { n.setAttribute('data-sk-art', ''); initDusk(n); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); ScrollTrigger.refresh(); });
})();
